import React from 'react';
import styles from './Magazine.module.css';

const Magazine: React.FC = () => {
  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <div className={styles.content}>
          <h2 className={styles.title}>B2B LE MAGAZINE</h2>
          <p className={styles.text}>
            Ce premier numéro explore la transformation digitale du B2B, mettant en
            lumière les stratégies gagnantes et les technologies disruptives qui
            redéfinissent le secteur.
          </p>
          <p className={styles.text}>
            À travers des interviews exclusives, des success stories inspirantes et
            des analyses pointues, le magazine dévoile les secrets d'une
            digitalisation réussie.
          </p>
          <p className={styles.text}>
            Du e-commerce B2B aux nouvelles solutions de recherche et
            d'automatisation, plongez au cœur d'un écosystème en pleine mutation où
            data, contenu et business s'entrelacent pour façonner l'avenir du
            commerce.
          </p>
          <p className={styles.text}>
            Une lecture essentielle pour ceux qui veulent garder une longueur
            d'avance !
          </p>
          <a href="https://www.calameo.com/read/007862432de0f2263a779" target="_blank" rel="noopener noreferrer" className={styles.button}>
            LIRE LE MAGAZINE
          </a>
        </div>
        <div className={styles.imageWrapper}>
          <img
            src="/assets/images/magazine-cover.jpg"
            alt="B2B Le Magazine"
            className={styles.image}
          />
        </div>
      </div>
    </section>
  );
};

export default Magazine;
